import {
  OLIGO_NAME,
  RESEARCHER_NAME,
  RNA_TYPE,
  BASE_COUNT,
  SENSE_SEQUENCE,
  SENSE_MODIFICATION,
  OVERHANG,
  DUPLEX,
  ANTISENSE_SEQUENCE,
  ANTISENSE_MODIFICATION,
  ANTISENSE_OVERHANG,
  ANTISENSE_BASE_COUNT,
  SCALE,
  PURITY,
  SCALE_OPTIONS,
  PURITY_OPTIONS,
  RNA_OPTIONS,
} from 'src/components/OligosForm/constants';

export default class OligoFormState {
  static getDefaultFormState() {
    return {
      [RESEARCHER_NAME]: { value: '', isValid: false },
      [OLIGO_NAME]: { value: '', isValid: false },
      [RNA_TYPE]: { value: RNA_OPTIONS.SI_RNA, isValid: true },
      [SENSE_SEQUENCE]: { value: '', isValid: false },
      [SENSE_MODIFICATION]: { value: '', isValid: true },
      [OVERHANG]: { value: '', isValid: true },
      [DUPLEX]: { value: false, isValid: true },
      [BASE_COUNT]: { value: 0, isValid: true },
      [ANTISENSE_SEQUENCE]: { value: '', isValid: true },
      [ANTISENSE_MODIFICATION]: { value: '', isValid: true },
      [ANTISENSE_OVERHANG]: { value: '', isValid: true },
      [ANTISENSE_BASE_COUNT]: { value: 0, isValid: true },
      [SCALE]: { value: SCALE_OPTIONS.NMOLE20, isValid: true },
      [PURITY]: { value: PURITY_OPTIONS.DESALTED, isValid: true },
    };
  }
}
